const Option = ({ children, value }) => <option className="hover:bg-zinc-50" value={value}>{children}</option>;

export default Option;